// extracted by mini-css-extract-plugin
export var active = "_95-7";
export var container = "_95-0";
export var evenWidth = "_95-4";
export var large = "_95-5";
export var outlet = "_95-8";
export var slide = "_95-2";
export var small = "_95-6";
export var tab = "_95-3";
export var tabs = "_95-1";